import { gql } from "@apollo/client";

export const LOAD_STATIONEN = gql`
  {
    stationCollection(order: [stationsnummer_ASC]) {
      items {
        stationsnummer
        stationsname
        beschreibung
        stationsbild {
          url
        }
        uebungenCollection {
          items {
            titel
          }
        }
      }
    }
  }
`;

export const GET_EXERCISES = gql`
  query GetExercises($stNr: Int!) {
    stationCollection(where: { stationsnummer: $stNr }) {
      items {
        stationsnummer
        stationsname
        stationsbild {
          url
        }
        uebungenCollection(limit: 10) {
          items {
            titel
            thumbnail {
              url
            }
          }
        }
      }
    }
  }
`;

export const GET_EXERCISE_DETAILS = gql`
  query GetExerciseDetails($stNr: Int!) {
    stationCollection(where: { stationsnummer: $stNr }) {
      items {
        uebungenCollection(limit: 10) {
          items {
            titel
            instruction {
              json
            }
            variation {
              json
            }
            tipp {
              json
            }
            tipp {
              json
            }
            video {
              url
            }
            musclesChart {
              percentageArms
              percentageAbs
              percentageLegs
              percentageUpperBody
              percentageAss
            }
          }
        }
      }
    }
  }
`;

export const GET_MAP_DATA = gql`
  {
    stationCollection(order: stationsnummer_ASC) {
      items {
        stationsnummer
        stationsname
        position {
          lat
          lon
        }
        uebungenCollection {
          items {
            titel
          }
        }
      }
    }
    historicPointCollection {
      items {
        name
        position {
          lat
          lon
        }
      }
    }
  }
`;

export const GET_NOTIFICATION = gql`
  {
    mitteilungCollection {
      items {
        title
        content {
          __typename
          ... on Umfrage {
            title
            shortDescription
            description
            iframe
          }
          ... on Announcement {
            title
            shortDescription
            description
          }
        }
      }
    }
  }
`;
